import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'replaceNewline'
})
export class ReplaceNewlinePipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    const message = value || '';

    const search = '\\n';
    const searchRegExp = new RegExp(search, 'g');
    const formattedMessage = message.replace(searchRegExp, '<br/>');

    return formattedMessage;
  }
}
